















import OtDocumentLayout from '@/components/documents/document-layout/ot-document-layout.vue';
import { Component, Vue } from 'vue-property-decorator';
import { ROUTE_CONTRACT_DOCUMENT, ROUTE_CONTRACT_DOCUMENT_ASSOCIATIONS } from './contract-routes';

@Component({
  components: {
    OtDocumentLayout,
  },
})
export default class OtProjectDocumentLayout extends Vue {
  private get detailsRouteName() {
    return ROUTE_CONTRACT_DOCUMENT;
  }
  private get associationsRouteName() {
    return ROUTE_CONTRACT_DOCUMENT_ASSOCIATIONS;
  }
}
